@for (item of items; track item; let last = $last) {
  <i
    class=" va-m inline-block"
    [class.m-r-1]="!last"
    [class.icon-star-empty]="item >= this.maxHalf"
    [class.icon-star-half]="item < this.maxHalf && item >= this.maxFull"
  [class.icon-star]="item < this.maxFull"></i>
}